module.exports = __webpack_public_path__ + "static/media/material_icon_simple.27d942e3.svg";